"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const Error_1 = __importDefault(require("@material-ui/icons/Error"));
const react_router_dom_1 = require("react-router-dom");
const components_1 = require("components");
function CustomErrorPage({ title, description, withBackButton = false, }) {
    const history = (0, react_router_dom_1.useHistory)();
    return ((0, jsx_runtime_1.jsx)("div", { className: "page-container centered-container", children: (0, jsx_runtime_1.jsxs)("div", { className: "error-page-container", children: [(0, jsx_runtime_1.jsx)(Error_1.default, { style: { fontSize: 100 }, color: "disabled" }), (0, jsx_runtime_1.jsx)("h4", { className: "error-page-title", children: title }), (0, jsx_runtime_1.jsx)("p", { className: "error-page-paragraph", children: description }), withBackButton && ((0, jsx_runtime_1.jsx)(components_1.Button, { "data-testid": "back-button", type: "button", className: "button-warn-outline", onClick: () => history.goBack(), children: "Go Back" }))] }) }));
}
exports.default = CustomErrorPage;
